export default {"src":"/_next/static/media/logoMega.225e7bec.svg","height":42,"width":136,"blurWidth":0,"blurHeight":0};